import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

// '/' — список проектов; '/p/:slug' — редактор проекта (slug фиксируется в auth store).
const routes: RouteRecordRaw[] = [
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterView.vue'),
    beforeEnter: () => {
      const auth = useAuthStore();
      if (auth.isAuthed) return { name: 'home' as const };
    },
  },
  { path: '/confirm', name: 'confirm', component: () => import('@/views/ConfirmView.vue') },
  // '/' — вошедший: список проектов; гость: редирект на корень (статический лендинг).
  { path: '/', name: 'home', component: () => import('@/views/HomeView.vue') },
  {
    path: '/p/:slug',
    name: 'editor',
    component: () => import('@/views/EditorView.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/AccountView.vue'),
    beforeEnter: () => {
      const auth = useAuthStore();
      if (!auth.isAuthed) return { name: 'login' as const };
    },
  },
  {
    path: '/audit',
    name: 'audit',
    component: () => import('@/views/AccountView.vue'),
    beforeEnter: () => {
      const auth = useAuthStore();
      if (!auth.isAuthed) return { name: 'login' as const };
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/AccountView.vue'),
    beforeEnter: () => {
      const auth = useAuthStore();
      if (!auth.isAuthed) return { name: 'login' as const };
    },
  },
  { path: '/:rest(.*)*', redirect: '/' },
];

export const router = createRouter({
  // Base из vite (prod: /app/, dev: /app/ на :5173) — внутренние пути (/p/:slug и т.д.)
  // не меняются, префикс добавляется автоматически.
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// Проект фиксируем на КАЖДОЙ навигации в /p/:slug: beforeEnter не срабатывает
// при смене параметра того же роута (/p/a → /p/b).
router.beforeEach((to) => {
  if (to.name === 'editor') {
    const auth = useAuthStore();
    if (!auth.isAuthed) return { name: 'login' as const };
    const slug = Array.isArray(to.params.slug) ? to.params.slug[0] : to.params.slug;
    if (slug) auth.setProject(String(slug));
  }
  return true;
});
